// ═══ 말소대행신청 (B3 S2) — /main/m/request · 한 화면(Jin 11/04 simplify) → 완료 ═══
// 번호 입력칸 + [추가](엔터도) → 신청 차량 상자(번호 목록 ✕ · 대행사 거래처 줄, Jin 11/04) → 서류 전달 방식·수거 주소(항상 보임) → '추가 옵션' 요약 한 줄 + [변경 ›] 인라인 펼침
// → 안내 줄 → [n대 말소대행신청]. 수거 주소 = 회사 주소 / 픽업 주소(입력칸) — 회사 주소가 비면 픽업 주소를 미리 고른다(Jin 11/04 §4).
// 수거 요청이면 주소 필수(§5) — 쓸 주소가 비면 [신청] 꺼진 모양 + 칸 아래 안내, 회사 주소가 비면 '회사 주소'는 못 고른다.
// [주소 검색] = AddrPickModal(Daum Postcode) — 스크립트가 없으면 버튼을 숨긴다(직접 입력).
// 같은 번호는 trim 문자열 그대로만 비교해 다시 넣지 않는다(정규화 비교는 서버 몫). 신청 때 입력칸에 남은 번호도 넣는다.
// 서류는 업체가 준비(J3) — 전체 기능 소개 카드(제목 → ✓ 두 항목 → 전체 폭 보조 버튼 [전체기능 둘러보기] → (대표) 전환 방법 한 줄, simplify §8·§9·§12)
// = 누구나 이 브라우저에서만 전체 기능 둘러보기 시작(서버 호출 없음, §7 — 입력이 있으면 버리기 확인 먼저) → /main/dashboard.
// 영구 전환은 띠의 [계속 쓰기]·더보기.
// 앱 malso_request_flow_screen.dart 와 같은 흐름·직렬화(requestLogic.buildQuickBody). 대행사는 서버 자동(agencyId 미전송) —
// 부가서비스 칩은 GET /cancel-agencies 가 정확히 1곳일 때만. 오류 응답 원문은
// 화면·로그에 올리지 않는다(문구 키만). 경로 문자열은 api.js 에만 둔다.
// 대행사(GET /my/malso-clients isBroker, W1a): 목록 아래 차마다 거래처를 고르고(다 골라야 [신청]) 서류 전달 방식 아래에서 거래처 묶음마다
// 수거 주소를 고른다 — 공통 칸의 수거 주소 선택은 숨긴다. 목록을 읽는 동안은 [신청]을 잠근다. 비대행사·실패(404 포함)는 화면·body 모두 현행 그대로.
// props: { user, showToast }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T, R, S, FONT } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { useIsMobile } from '../../../utils/useMobile';
import ErrorText from '../../simple/parts/ErrorText';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import { describeSimpleError } from '../../simple/errors';
import { card as cardBase, input as inputSt, textarea as textareaSt, warnSt, CtaBar, btnNavy, btnPlain, btnDisabled } from '../../simple/screens/request/bits';
import { canOfferMalso, setMalsoPreview } from '../../simple/screenMode';
import AddrPickModal from '../../simple/screens/request/AddrPickModal';
import { quickRequest, listAgencies, extraServices, listBuyers, getCompany, listMalsoClients, putMalsoClientPickup } from '../api';
import { brokerPickupReady, buildQuickBody, defaultPickup, groupCards, mapQuickError, newCard, pickedClient } from '../requestLogic';
import MalsoCarCard, { PerCarSheet, ServiceChips } from '../parts/MalsoCarCard';
import UnitPickSheet, { UnitRows, carLabel } from '../parts/UnitPickSheet';
import BrokerGroup from '../parts/BrokerGroup';
import Glyph from '../../simple/parts/Glyph';
import JoinWaitCard from '../parts/JoinWaitCard';
import { refreshMalsoJoin } from '../joinRefresh';

var LIST = '/main/m/malso';
// pickupKind 'company' = 회사 주소(addrKr)로 수거 · 'pickup' = 입력한 픽업 주소 (앱 CancelPickupAddressChoice). 대행사는 쓰지 않는다.
var COMMON = { cancelType: '수출말소', intakeMethod: '수거', urgent: false, services: [], buyerName: '', memo: '', pickupAddress: '', pickupKind: 'pickup' };

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 760, margin: '0 auto', width: '100%' };
var headRow = { display: 'flex', alignItems: 'center', gap: 8 };
var backBtn = { border: 0, background: 'none', padding: 0, cursor: 'pointer', color: T.muted, fontSize: 18, lineHeight: 1, fontFamily: 'inherit' };
var titleSt = { fontSize: FONT.title, fontWeight: 800, letterSpacing: '-.35px', color: T.navy, margin: 0 };
var box = Object.assign({}, cardBase, { padding: 16 });
var boxTitle = { fontSize: FONT.cardTitle, fontWeight: 800, color: T.ink };
var col = { display: 'flex', flexDirection: 'column', gap: 5 };
var labSt = { fontSize: FONT.label, fontWeight: 700, color: T.muted };
var wrap = { display: 'flex', flexWrap: 'wrap', gap: 6 };
// 차량번호 입력이 화면에서 가장 먼저 눈에 띄게(Jin 11/05) — 위 라벨 · accent 2px 테두리 입력칸 · 채운 주 버튼 [추가].
var addRowSt = { display: 'flex', gap: 8 };
var draftCol = { display: 'flex', flexDirection: 'column', gap: 6 };
var draftSt = Object.assign({}, inputSt, { flex: 1, minWidth: 0, border: '2px solid ' + T.accent });
var addPrimary = Object.assign({}, S.btnNavy, { height: 38, flex: 'none' });
var addBtn = Object.assign({}, S.btn, { height: 38, flex: 'none' });
// 서류 전달 방식·수거 주소 선택 = 중립 칩 + 라디오 표시만(바탕 칠 없음, Jin 11/05). 동그라미는 UnitPickSheet 라디오와 같은 모양.
var radioOff = { flex: 'none', width: 16, height: 16, borderRadius: R.pill, border: '2px solid ' + T.line, boxSizing: 'border-box' };
var radioOn = Object.assign({}, radioOff, { border: '5px solid ' + T.accent });
var optText = Object.assign({}, col, { flex: 1, minWidth: 0 });
var summarySt = { fontSize: 12.5, color: T.muted, lineHeight: 1.5 };
var addrSt = { fontSize: 12.5, color: T.dim, lineHeight: 1.5 };
var pickupRow = { display: 'flex', gap: 8 };
var listCol = { display: 'flex', flexDirection: 'column', gap: 8 };
var optBody = { display: 'flex', flexDirection: 'column', gap: 14 };
var info = { fontSize: 11.5, color: T.muted, textAlign: 'center' };
var doneIcon = { width: 48, height: 48, borderRadius: R.pill, background: T.okTint, color: T.ok, display: 'grid', placeItems: 'center', fontSize: 24, fontWeight: 800 };
var doneRow = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, fontSize: 12.5 };
var waitPill = { marginInlineStart: 'auto', fontSize: FONT.badge, fontWeight: 700, padding: '3px 8px', borderRadius: R.pill, background: T.track, color: T.muted };
var pickHintSt = Object.assign({}, info, { color: T.warn, fontWeight: 600 });
// 전체 기능 소개 카드(앱 malsoFullPitch) — 위 '서류 전달 방식' 상자와 같은 흰 카드 + 테두리(§10) · 제목 앞 accent 앱 글리프 ·
// 보조 버튼(흰 바탕 + accent 테두리·글자)으로 하단 주 버튼과 구분. 글자는 keep-all — 한국어 낱말이 줄 끝에서 쪼개지지 않게(§9).
var pitch = Object.assign({}, box, { gap: 8, wordBreak: 'keep-all' });
var pitchHead = { display: 'flex', alignItems: 'center', gap: 8 };
var pitchIcon = { flex: 'none', display: 'inline-flex', color: T.accent };
var pitchTitle = { fontSize: 16, fontWeight: 800, color: T.navy };
var pitchItem = { display: 'flex', alignItems: 'flex-start', gap: 6, fontSize: 14, color: T.ink, lineHeight: 1.5 };
var pitchCheck = { flex: 'none', color: T.accent, fontWeight: 800 };
var pitchHowTo = { fontSize: 12.5, color: T.muted, lineHeight: 1.5 };
var pitchBtn = Object.assign({}, btnPlain, { width: '100%', marginTop: 6, background: T.card, border: '1px solid ' + T.accent, color: T.accent });

function withKey(o, k, v) { var n = Object.assign({}, o); n[k] = v; return n; }

function MalsoRequest(props) {
  var t = useT();
  var navigate = useNavigate();
  var isMobile = useIsMobile();
  var seqRef = useRef(0);
  var aliveRef = useRef(true);
  var draftRef = useRef(null);
  var pickupRef = useRef(null);

  var stCards = useState([]); var cards = stCards[0], setCards = stCards[1];
  var stDraft = useState(''); var draft = stDraft[0], setDraft = stDraft[1];
  var stOpen = useState(false); var open = stOpen[0], setOpen = stOpen[1];
  var stDone = useState(false); var done = stDone[0], setDone = stDone[1];
  var stCommon = useState(COMMON); var common = stCommon[0], setCommon = stCommon[1];
  var stOpts = useState([]); var opts = stOpts[0], setOpts = stOpts[1];
  var stNames = useState([]); var names = stNames[0], setNames = stNames[1];
  var stOv = useState({}); var ov = stOv[0], setOv = stOv[1];
  var stPerCar = useState(false); var perCar = stPerCar[0], setPerCar = stPerCar[1];
  var stSheet = useState(null); var sheetKey = stSheet[0], setSheet = stSheet[1];
  var stBusy = useState(false); var busy = stBusy[0], setBusy = stBusy[1];
  var stErr = useState(''); var err = stErr[0], setErr = stErr[1];
  var stCreated = useState([]); var created = stCreated[0], setCreated = stCreated[1];
  // 버리기 확인 — 확인하면 할 일: 'list'(✕ 닫기) | 'preview'(전체기능 보러가기) | null(닫힘)
  var stDiscard = useState(null); var discard = stDiscard[0], setDiscard = stDiscard[1];
  var stAddrPick = useState(false); var addrPick = stAddrPick[0], setAddrPick = stAddrPick[1];
  // 대행사 — clients null = 읽는 중, 실패·404 = { isBroker:false }. unitOf {[card.key]:unitId} · pickupOf {[unitId]:{kind,address}} · added {[unitId]:true}
  var stClients = useState(null); var clients = stClients[0], setClients = stClients[1];
  var stUnitOf = useState({}); var unitOf = stUnitOf[0], setUnitOf = stUnitOf[1];
  var stPickupOf = useState({}); var pickupOf = stPickupOf[0], setPickupOf = stPickupOf[1];
  var stAdded = useState({}); var added = stAdded[0], setAdded = stAdded[1];
  var stPickKey = useState(null); var pickKey = stPickKey[0], setPickKey = stPickKey[1];
  var stAgency = useState(''); var agencyName = stAgency[0], setAgencyName = stAgency[1];
  var stAddr = useState(''); var companyAddr = stAddr[0], setCompanyAddr = stAddr[1];
  // 대표 링크 가입 업체 — 대행사 거래처 연결 전이면 흐름 대신 대기 안내(주소로 바로 들어와도). 서버 400 JOIN_PENDING 도 같은 안내 —
  //   그때 user.malsoJoin 이 없으면(옛 세션) 대행사명은 이 화면이 읽은 단일 대행사명.
  var stJoin = useState(false); var joinPending = stJoin[0], setJoinPending = stJoin[1];
  var join = (props.user && props.user.malsoJoin) || (joinPending ? { agencyName: agencyName } : null);
  var broker = !!(clients && clients.isBroker);

  var setC = function (k, v) { setCommon(function (p) { var n = Object.assign({}, p); n[k] = v; return n; }); };
  var loadClients = function () {
    return listMalsoClients().then(function (res) {
      if (aliveRef.current) setClients(res && res.isBroker ? res : { isBroker: false });
    }).catch(function () { if (aliveRef.current) setClients(function (p) { return p || { isBroker: false }; }); });
  };

  // 대기 안내 중이면 진입 때 한 번 다시 읽는다(말소 홈과 같음) — 연결됐으면 세션 갱신으로 흐름이 열린다.
  useEffect(function () { refreshMalsoJoin(props.user); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    aliveRef.current = true;
    loadClients();
    listAgencies().then(function (list) {
      if (!Array.isArray(list) || list.length !== 1) return null;
      if (aliveRef.current) setAgencyName(String(list[0].name || ''));
      return extraServices(list[0].id).then(function (o) { if (aliveRef.current && Array.isArray(o)) setOpts(o); });
    }).catch(function () { /* 칩 섹션 숨김 — 신청은 막지 않는다 */ });
    listBuyers().then(function (rows) {
      var out = [];
      (Array.isArray(rows) ? rows : []).forEach(function (b) { var n = String((b && b.name) || '').trim(); if (n && out.indexOf(n) < 0) out.push(n); });
      if (aliveRef.current) setNames(out);
    }).catch(function () { /* 자동완성만 없음 */ });
    var u = props.user || {};
    getCompany(u.activeCompanyId || u.companyId).then(function (c) {
      var addr = String((c && c.pickupAddress) || '').trim();
      var base = String((c && c.addrKr) || '').trim();
      if (!aliveRef.current) return;
      setCompanyAddr(base);
      // 기본 선택 — 저장된 픽업 주소 → 픽업 주소(채움) · 없고 회사 주소 있음 → 회사 주소 · 둘 다 없음 → 픽업 주소 + 안내
      setCommon(function (p) { return p.pickupAddress ? p : Object.assign({}, p, { pickupAddress: addr, pickupKind: addr || !base ? 'pickup' : 'company' }); });
    }).catch(function () { /* 빈 칸 — 픽업 주소 + 안내 */ });
    return function () { aliveRef.current = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 입력칸 번호 — trim 값, 이미 목록에 같은 문자열이 있으면 '' (다시 넣지 않는다).
  var draftNo = draft.trim();
  var draftNew = draftNo && !cards.some(function (c) { return c.carNo === draftNo; }) ? draftNo : '';
  var withDraft = function () {
    if (!draftNew) return cards;
    seqRef.current += 1;
    return cards.concat([newCard(seqRef.current, draftNew)]);
  };

  // [추가]·엔터 — 빈 값 무시, 같은 번호면 짧은 안내만. 칸을 비우고 포커스를 둔다.
  var addDraft = function () {
    if (draftRef.current) draftRef.current.focus();
    if (!draftNo) return;
    if (!draftNew && props.showToast) props.showToast(t('malsoModeCarNoAlreadyAdded'));
    setCards(withDraft());
    setDraft('');
    setErr('');
  };

  // ② 고르기 — 이 차(+ 체크 켜짐이면 아직 안 고른 차들)에 거래처를 넣고, 그 묶음 수거 주소가 없으면 기본값.
  // 새 거래처(isNew)는 목록에 없으면 바로 붙이고 '새 거래처' 표시, 목록은 다시 읽는다(409 = 이미 있던 거래처).
  var pickUnit = function (c, apply, isNew) {
    var known = clients.clients.filter(function (x) { return x.id === c.id; })[0];
    var client = known || c;
    if (isNew) {
      if (!known) {
        setAdded(function (p) { return withKey(p, c.id, true); });
        setClients(function (p) { return Object.assign({}, p, { clients: p.clients.concat([c]) }); });
      }
      loadClients();
    }
    setUnitOf(function (p) {
      var n = Object.assign({}, p);
      cards.forEach(function (x) { if (x.key === pickKey || (apply && !pickedClient(clients.clients, p, x.key))) n[x.key] = client.id; });
      return n;
    });
    setPickupOf(function (p) { return p[client.id] ? p : withKey(p, client.id, defaultPickup(client)); });
    setPickKey(null);
  };

  // 주소 검색 결과 → 픽업 주소 칸에 채우고 커서를 끝에(상세주소를 이어 쓴다). 빈 값(임베드 실패)은 닫기만.
  var onAddrPick = useCallback(function (addr) {
    setAddrPick(false);
    if (!addr) return;
    setCommon(function (p) { return Object.assign({}, p, { pickupAddress: addr }); });
    setTimeout(function () { var el = pickupRef.current; if (el) { el.focus(); el.setSelectionRange(addr.length, addr.length); } }, 0);
  }, [setAddrPick, setCommon]);

  var setOverride = function (key, value) {
    setOv(function (p) { var n = Object.assign({}, p); if (value) n[key] = value; else delete n[key]; return n; });
  };

  // 대행사 — 모든 차 거래처 고름(아니면 버튼 꺼짐 + 안내 줄). 수거 요청이면 쓸 주소가 있어야 신청(§5) — 비면 꺼진 모양 + 칸 아래 안내,
  // 누르면 토스트: 대행사 = '다른 주소 입력' 묶음 주소 · 그 외 = 고른 회사 주소/픽업 주소.
  var unpicked = broker ? cards.filter(function (c) { return !pickedClient(clients.clients, unitOf, c.key); }) : [];
  var groups = broker ? groupCards(cards, unitOf, clients.clients) : [];
  var total = cards.length + (draftNew ? 1 : 0);
  var submitOff = busy || !total || clients === null || unpicked.length > 0;
  var addrOk = broker ? brokerPickupReady(groups, pickupOf, common.intakeMethod)
    : common.intakeMethod !== '수거' || !!(common.pickupKind === 'company' ? companyAddr : common.pickupAddress.trim());
  var submitReady = !submitOff && addrOk;
  var submitSt = isMobile ? Object.assign({}, btnNavy, { flex: 1 }) : btnNavy;
  var submit = function () {
    if (submitOff) return;
    // 입력칸에 남은 번호도 목록에 넣고 신청 — 대행사는 그 차 거래처를 먼저 골라야 하므로 넣기만 한다(안내 줄이 뜬다).
    var list = withDraft();
    if (draftNo) { setCards(list); setDraft(''); }
    if (draftNew && broker) return;
    if (!submitReady) {
      if (props.showToast) props.showToast(t('malsoModeBrokerPickupCustomNeeded'), 'err');
      return;
    }
    setErr('');
    setBusy(true);
    setCards(list.map(function (c) { return c.exists ? Object.assign({}, c, { exists: false }) : c; }));
    // 신청 성공 뒤 저장할 거래처 주소 — 수거 요청 + '다른 주소 입력' + 본인 아님. 실패해도 신청 결과는 성공.
    var saves = broker && common.intakeMethod !== '방문' ? groups.filter(function (g) {
      return !g.client.isSelf && (pickupOf[g.unitId] || {}).kind === 'custom';
    }) : [];
    var sent = !broker && common.pickupKind === 'company' ? Object.assign({}, common, { pickupAddress: companyAddr }) : common;
    quickRequest(buildQuickBody(list, sent, ov, broker ? { unitOf: unitOf, pickupOf: pickupOf } : undefined)).then(function (res) {
      if (!aliveRef.current) return;
      setCreated((res && res.created) || []);
      setDone(true);
      if (broker) {
        Promise.all(saves.map(function (g) { return putMalsoClientPickup(g.unitId, pickupOf[g.unitId].address.trim()); }))
          .catch(function () { /* 주소 저장 실패는 신청과 무관 */ }).then(loadClients);
      }
    }).catch(function (e) {
      if (!aliveRef.current) return;
      if (e && e.code === 'JOIN_PENDING') { setJoinPending(true); return; }
      var m = mapQuickError(e);
      if (m && m.unitIndex != null) {   // UNIT_NOT_FOUND — 그 거래처를 쓰던 차를 전부 비운다(목록도 다시 읽는다)
        var badId = list[m.unitIndex] ? unitOf[list[m.unitIndex].key] : 0;
        setUnitOf(function (p) { var n = {}; Object.keys(p).forEach(function (k) { if (p[k] !== badId) n[k] = p[k]; }); return n; });
        loadClients();
        if (props.showToast) props.showToast(t(m.key, m.vars), 'err');
      }
      if (m && m.existing) {   // CARNO_IN_PROGRESS — 서버가 준 카드 위치(body.cars 순서 = cards 순서)만 '진행 중'
        setCards(function (prev) { return prev.map(function (c, i) { return Object.assign({}, c, { exists: m.existing.indexOf(i) >= 0 }); }); });
      }
      setErr(m ? t(m.key, m.vars) : describeSimpleError(t, e));
    }).then(function () { if (aliveRef.current) setBusy(false); });
  };

  var again = function () {
    setCards([]); setDraft(''); setOpen(false); setOv({}); setPerCar(false); setErr(''); setCreated([]); setDone(false);
    setUnitOf({}); setPickupOf({}); setAdded({});
    setCommon(function (p) { return Object.assign({}, COMMON, { pickupAddress: p.pickupAddress, pickupKind: p.pickupKind }); });
  };

  var navBtn = function (label, onClick, enabled, id, plain) {
    var base = plain ? btnPlain : btnNavy;
    if (isMobile) base = Object.assign({}, base, { flex: 1 });   // 하단 고정 바 — 바 전체 폭 (검차 셸 StepVehicle 선례)
    return (<button type="button" style={enabled ? base : Object.assign({}, base, btnDisabled)} disabled={!enabled}
      data-testid={id} onClick={onClick}>{label}</button>);
  };
  var block = function (labelKey, child) { return <div style={col}><span style={labSt}>{t(labelKey)}</span>{child}</div>; };
  // items: [[값, 문구 키, 꺼짐?]] · radioLabel 이 있으면 라디오 묶음 — 고른 칸도 같은 중립 칩, 표시는 라디오 동그라미만.
  var seg = function (k, items, radioLabel) {
    var radio = !!radioLabel;
    return (<div style={wrap} role={radio ? 'radiogroup' : undefined} aria-label={radioLabel}>{items.map(function (it) {
      var on = common[k] === it[0];
      return (<button key={it[0]} type="button" style={Object.assign({}, on && !radio ? S.chipOn : S.chip, it[2] ? btnDisabled : null)}
        role={radio ? 'radio' : undefined} aria-checked={radio ? on : undefined} aria-pressed={radio ? undefined : on}
        disabled={!!it[2]} data-opt={k + ':' + it[0]} onClick={function () { setC(k, it[0]); }}>
        {radio ? <span style={on ? radioOn : radioOff} aria-hidden="true" data-radio={on ? '1' : '0'} /> : null}{t(it[1])}</button>);
    })}</div>);
  };

  // ✕ — 번호·입력이 있으면 버리기 확인 후에만 닫는다(앱 _close).
  var dirty = !done && (cards.length > 0 || !!draftNo || !!common.memo.trim() || !!common.buyerName.trim() || common.services.length > 0);
  var close = function () {
    if (dirty) setDiscard('list'); else navigate(LIST);
  };

  var header = (<div style={headRow}>
    <button type="button" style={backBtn} disabled={busy} data-testid="malso-req-back" aria-label={t('actionClose')}
      onClick={close}>✕</button>
    <h2 style={titleSt}>{t('malsoModeRequestCta')}</h2>
  </div>);

  if (join) {
    return (<div style={page} data-testid="malso-join-block">
      <div style={headRow}>
        <button type="button" style={backBtn} data-testid="malso-req-back" aria-label={t('actionClose')}
          onClick={function () { navigate(LIST); }}>✕</button>
        <h2 style={titleSt}>{t('malsoModeRequestCta')}</h2>
      </div>
      <JoinWaitCard agencyName={join.agencyName} />
    </div>);
  }

  if (done) {
    return (<div style={page} data-testid="malso-done">
      {header}
      <div style={Object.assign({}, box, { alignItems: 'center', textAlign: 'center' })}>
        <span style={doneIcon}>✓</span>
        <b style={{ fontSize: 17, color: T.ink }}>{t('malsoModeDoneTitle')}</b>
        <span style={{ fontSize: 13, color: T.muted }}>{t('malsoModeDoneBody')}</span>
      </div>
      {created.map(function (x) {
        return (<div key={x.id} style={doneRow}><b>{x.carNo || '-'}</b>
          <span style={waitPill}>{t('cancelAgencyStatusWaiting')}</span></div>);
      })}
      <CtaBar isMobile={isMobile}>
        {navBtn(t('malsoModeDoneMore'), again, true, 'malso-again', true)}
        {navBtn(t('malsoModeDoneGoList'), function () { navigate(LIST); }, true, 'malso-golist')}
      </CtaBar>
    </div>);
  }

  var exp = common.cancelType !== '폐차말소';
  var canPerCar = opts.length > 0 || exp;
  var sheetCard = cards.filter(function (c) { return c.key === sheetKey; })[0];
  var pickCard = broker ? cards.filter(function (c) { return c.key === pickKey; })[0] : null;
  // 둘러보기 시작 — 저장 → 셸 재판정(전체 기능 셸) → 이동. 이동을 먼저 하면 아직 말소 셸이라 catch-all 이 말소 홈으로 되돌린다.
  // 입력한 번호·칸이 있으면 ✕ 와 같은 버리기 확인을 먼저 띄운다.
  var startPreview = function () { setMalsoPreview(props.user, true); navigate('/main/dashboard'); };
  var askPreview = function () { if (dirty) setDiscard('preview'); else startPreview(); };
  var pickupOpen = common.intakeMethod === '수거';
  var canSearch = !!(window.daum && window.daum.Postcode);   // index.html 정적 스크립트 — 차단·오프라인이면 직접 입력만

  // '추가 옵션' 요약 한 줄 — 말소 구분 (+ 긴급 · 부가서비스 n · 바이어). 서류 전달 방식·수거 주소는 늘 펼쳐 보인다.
  var summary = [t(exp ? 'reqAdminCancelTypeExport' : 'reqAdminCancelTypeScrap'),
    common.urgent ? t('carCancelUrgentLabel') : '', common.services.length ? t('extraSvcTitle') + ' ' + common.services.length : '',
    exp ? common.buyerName.trim() : ''].filter(Boolean).join(' · ');

  var carCard = function (c) {
    return (<MalsoCarCard key={c.key} t={t} index={cards.indexOf(c) + 1} card={c} hasOverride={!!ov[c.key]}
      onRemove={function () { setCards(function (p) { return p.filter(function (x) { return x.key !== c.key; }); }); }}
      onPerCar={canPerCar && (perCar || ov[c.key]) ? function () { setSheet(c.key); } : null} />);
  };

  var options = (<div style={optBody} data-testid="malso-common">
    {seg('cancelType', [['수출말소', 'reqAdminCancelTypeExport'], ['폐차말소', 'reqAdminCancelTypeScrap']])}
    {exp ? block('buyersTitle', (<React.Fragment>
      <input style={inputSt} list="malso-buyers" value={common.buyerName} placeholder={t('malsoModeBuyerHint')} data-testid="malso-buyer"
        onChange={function (e) { setC('buyerName', e.target.value); }} />
      <datalist id="malso-buyers">{names.map(function (n) { return <option key={n} value={n} />; })}</datalist>
    </React.Fragment>)) : null}
    <div style={wrap}><button type="button" style={common.urgent ? S.chipOn : S.chip} aria-pressed={common.urgent} data-opt="urgent"
      onClick={function () { setC('urgent', !common.urgent); }}>{t('carCancelUrgentLabel')}</button></div>
    {opts.length ? block('extraSvcTitle', <ServiceChips options={opts} value={common.services} onChange={function (v) { setC('services', v); }} />) : null}
    {block('cancelAgencyDetailFieldMemo', (<textarea style={textareaSt} value={common.memo} data-testid="malso-memo"
      onChange={function (e) { setC('memo', e.target.value); }} />))}
    {canPerCar ? (<button type="button" style={Object.assign({}, S.link, { alignSelf: 'flex-start' })} data-testid="malso-percar"
      aria-pressed={perCar} onClick={function () { setPerCar(!perCar); }}>{t('malsoModePerCarOptions') + ' ›'}</button>) : null}
  </div>);

  return (<div style={page} data-testid="malso-request">
    {header}
    <div style={draftCol}>
      <label htmlFor="malso-carno-input" style={boxTitle} data-testid="malso-carno-label">{t('malsoModeFieldCarNo')}</label>
      <div style={addRowSt}>
        <input ref={draftRef} id="malso-carno-input" style={draftSt} value={draft} data-testid="malso-carno-input" placeholder={t('malsoModeCarNoHint')}
          enterKeyHint="done" onChange={function (e) { setDraft(e.target.value); }}
          onKeyDown={function (e) { if (e.key === 'Enter' && !e.nativeEvent.isComposing) { e.preventDefault(); addDraft(); } }} />
        <button type="button" style={addPrimary} data-testid="malso-add" onClick={addDraft}>{t('malsoModeAdd')}</button>
      </div>
    </div>
    <div style={box} data-testid="malso-car-list">
      <span style={boxTitle}>{t('malsoModeCarListTitle', { count: cards.length })}</span>
      {cards.length ? <div style={listCol}>{cards.map(carCard)}</div>
        : <span style={summarySt} data-testid="malso-car-empty">{t('malsoModeCarListEmpty')}</span>}
      {broker && cards.length ? (<UnitRows t={t} head={t('malsoModeBrokerCarCount', { count: cards.length }) + ' · ' + t('malsoModeBrokerPickEach')}
        cards={cards} unitOf={unitOf} clients={clients.clients} onOpen={setPickKey} />) : null}
    </div>
    <div style={box} data-testid="malso-intake">
      <span style={boxTitle}>{t('carCancelIntakeSection')}</span>
      {seg('intakeMethod', [['수거', 'carCancelIntakePickup'], ['방문', 'carCancelIntakeVisit']], t('carCancelIntakeSection'))}
      {pickupOpen && !broker ? block('carCancelPickupSection', (<React.Fragment>
        {seg('pickupKind', [['company', 'carCancelUseCompanyAddress', !companyAddr], ['pickup', 'carCancelUsePickupAddress']], t('carCancelPickupSection'))}
        {common.pickupKind === 'company' ? <span style={addrSt} data-testid="malso-company-addr">{companyAddr}</span>
          : (<div style={pickupRow}>
            <input ref={pickupRef} style={Object.assign({}, inputSt, { flex: 1, minWidth: 0 })} value={common.pickupAddress} data-testid="malso-pickup"
              aria-label={t('carCancelUsePickupAddress')} onChange={function (e) { setC('pickupAddress', e.target.value); }} />
            {canSearch ? (<button type="button" style={addBtn} data-testid="malso-pickup-search"
              onClick={function () { setAddrPick(true); }}>{t('simplePickAddr')}</button>) : null}
          </div>)}
        {common.pickupKind === 'pickup' && !common.pickupAddress.trim()
          ? <span style={warnSt} data-testid="malso-pickup-hint">{t('malsoModeBrokerPickupCustomNeeded')}</span> : null}
      </React.Fragment>)) : null}
      {pickupOpen && broker ? groups.map(function (g) {   // 거래처 묶음 — 본인 먼저, 묶음마다 수거 주소
        return (<BrokerGroup key={g.unitId} t={t} client={g.client} count={g.cards.length} isNew={!!added[g.unitId]}
          accountName={clients.accountName} collectAddr={String(common.pickupAddress).trim() || companyAddr} intakeMethod={common.intakeMethod}
          canSearch={canSearch} value={pickupOf[g.unitId]} onChange={function (v) { setPickupOf(function (p) { return withKey(p, g.unitId, v); }); }} />);
      }) : null}
    </div>
    <div style={box} data-testid="malso-options" data-open={open ? '1' : '0'}>
      <div style={headRow}>
        <div style={optText}>
          <span style={boxTitle}>{t('malsoModeOptionsTitle')}</span>
          {open ? null : <span style={summarySt} data-testid="malso-options-summary">{summary}</span>}
        </div>
        <button type="button" style={S.link} data-testid="malso-options-toggle" aria-expanded={open}
          onClick={function () { setOpen(!open); }}>{open ? t('malsoModeOptionsFold') : t('malsoModeOptionsChange') + ' ›'}</button>
      </div>
      {open ? options : null}
    </div>
    <div style={pitch} data-testid="malso-full-pitch">
      <div style={pitchHead}><span style={pitchIcon} data-testid="malso-pitch-icon"><Glyph id="apps" /></span>
        <b style={pitchTitle}>{t('malsoModeFullPitchTitle')}</b></div>
      {t('malsoModeFullPitchBody').split('\n').map(function (line) {
        return (<div key={line} style={pitchItem} data-testid="malso-pitch-item"><span style={pitchCheck} aria-hidden="true">✓</span><span>{line}</span></div>);
      })}
      <button type="button" style={pitchBtn} data-testid="malso-preview-start" onClick={askPreview}>{t('malsoModeFullBannerAction')}</button>
      {/* 완전히 전환하는 방법 — 전환 권한(canOfferMalso)이 있는 사람에게만 (§12). 웹 전용 문구 — 웹 말소 셸엔 '모드 변경' 단계가 없고
          더보기(≥1024 는 회사명 메뉴)의 '오토덱스 전체 기능으로 전환' 행이 바로 있다. 앱 문구 malsoModeFullPitchHowTo 는 앱 키 맞춤용으로만 남는다. */}
      {canOfferMalso(props.user) ? <span style={pitchHowTo} data-testid="malso-pitch-howto">{t('malsoModeFullPitchHowToWeb')}</span> : null}
    </div>
    {unpicked.length ? (<div style={pickHintSt} data-testid="malso-pick-hint">
      {t('malsoModeBrokerPickHint', { car: carLabel(t, unpicked[0]) })}</div>) : null}
    <ErrorText>{err}</ErrorText>
    <CtaBar isMobile={isMobile}>
      {/* 수거 주소가 비었을 때는 꺼진 모양이지만 눌리고, 누르면 토스트로 알린다(앱과 같게, Jin 10/28 · 주소 필수 §5).
          처리 중·읽는 중·번호 0대·거래처 미선택은 진짜 disabled. */}
      <button type="button" data-testid="malso-submit" style={submitReady ? submitSt : Object.assign({}, submitSt, btnDisabled)}
        disabled={submitOff} aria-disabled={!submitReady} onClick={submit}>
        {busy ? t('malsoModeSubmitting') : t('malsoModeSubmitWithCount', { count: total })}</button>
    </CtaBar>
    {pickCard ? (<UnitPickSheet t={t} card={pickCard} clients={clients.clients} selectedId={unitOf[pickCard.key] || 0}
      canAdd={(props.user || {}).currentRole === 'owner'} accountName={clients.accountName} agencyName={agencyName}
      onPick={pickUnit} onClose={function () { setPickKey(null); }} />) : null}
    <AddrPickModal t={t} open={addrPick} onPick={onAddrPick} onClose={function () { setAddrPick(false); }} />
    {sheetCard ? (<PerCarSheet t={t} card={sheetCard} options={opts} exportCancel={exp} value={ov[sheetKey]}
      onSave={function (v) { setOverride(sheetKey, v); setSheet(null); }} onClose={function () { setSheet(null); }} />) : null}
    <ConfirmSheet open={!!discard} title={t('malsoSheetDiscardTitle')} sub={t('malsoSheetDiscardBody')} confirmLabel={t('actionClose')}
      onConfirm={function () { var next = discard; setDiscard(null); if (next === 'preview') startPreview(); else navigate(LIST); }}
      onClose={function () { setDiscard(null); }} />
  </div>);
}

export default MalsoRequest;
